import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import type { Vendor } from '@pedestal-panels/contracts';

/**
 * Sony MSU-3000 — master setup unit, multi-camera switching.
 *
 * Phase 1 reference panel; validates Sony tokens across a 2U rack form
 * factor distinct from the RCP-3500 desk surface.
 */
export const meta = {
  id: 'msu-3000',
  vendor: 'sony' as Vendor,
  model: 'MSU-3000',
  productName: 'Sony MSU-3000',
} as const;

@customElement('panel-msu-3000')
export class PanelMsu3000Element extends LitElement {
  static override styles = [
    css`
      :host {
        display: block;
        inline-size: 100%;
        container-type: inline-size;
      }
    `,
  ];

  override render() {
    return html`<chassis-frame view-box="0 0 1000 600"></chassis-frame>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'panel-msu-3000': PanelMsu3000Element;
  }
}
